import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import {getSearchFaq} from "../property/helpers/search_helper";
import {isEmpty} from "../../helpers/helpers";
import FaqsWidget from "../../molecules/widgets/faqs";

const SearchFaqs = ({ssrFaqsList, searchParams, skeleton}) => {
    const [faqs, setFaqs] = useState(ssrFaqsList ?? []);

    useEffect(() => {
        if (!skeleton) {
            getSearchFaq(searchParams).then(widgets => {
                setFaqs(widgets)
            })
        }
    }, [searchParams, skeleton]);

    if (faqs.length) {
        return (
            <Sections className="container">
                <FaqsWidget faqs={faqs}/>
            </Sections>
        );
    } else {
        return ''
    }
};

export default React.memo(SearchFaqs);


const Sections = styled.div`
    margin-bottom: 80px;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        margin-bottom: 64px;
    }
`;